import { isNil } from 'lodash-es';

import { isParseableDate } from './is-date.js';
import { formatDateToISOString } from '../../../tables/utils/download-utils.js';

export const parseDataToDate = (value: unknown) => {
  if (isNil(value)) {
    return '';
  }
  return isParseableDate(value) ? formatDateToISOString(value) : value;
};
